import { Navigate, Routes as ReactRouterRoutes, Route } from 'react-router';
import { useAppSelector } from '../../../../hooks';
import {
    isAuditorViewAccessible,
    isCarrierViewAccessible,
    isWarehouseEmployeeViewAccessible,
} from '../../selectors/Permissions.selectors';
import { Routing } from './Routing';
import { suspendPageLoad } from './suspendPageLoad';
import { RoutesProperties } from './types';

const WarehouseEmployeeTransportOrderCreationSidebar = suspendPageLoad(
    () =>
        import(
            '../views/warehouseEmployee/transportOrders/sidebars/createSidebar/WarehouseEmployeeTransportOrderCreationSidebar'
        ),
);
const CarrierTransportOrderEditSidebar = suspendPageLoad(async () => {
    const { CarrierTransportOrderEditSidebar } = await import(
        '../views/carrier/sidebars/transportOrderEditSidebar/CarrierTransportOrderEditSidebar'
    );
    return { default: CarrierTransportOrderEditSidebar };
});
const WarehouseEmployeeTransportOrderEditSidebar = suspendPageLoad(async () => {
    const { WarehouseEmployeeTransportOrderEditSidebar } = await import(
        '../views/warehouseEmployee/transportOrders/sidebars/editSidebar/WarehouseEmployeeTransportOrderEditSidebar'
    );
    return { default: WarehouseEmployeeTransportOrderEditSidebar };
});
const AuditorTransportOrderDetailsSidebar = suspendPageLoad(async () => {
    const { AuditorTransportOrderDetailsSidebar } = await import(
        '../views/auditor/sidebars/AuditorTransportOrderDetailsSidebar'
    );
    return { default: AuditorTransportOrderDetailsSidebar };
});
const WarehouseSelectionView = suspendPageLoad(
    () => import('../views/warehouseEmployee/warehouseSelection/WarehouseSelectionView'),
);
const WarehouseEmployeeView = suspendPageLoad(
    () => import('../views/warehouseEmployee/transportOrders/WarehouseEmployeeView'),
);
const CarrierView = suspendPageLoad(() => import('../views/carrier/CarrierView'));
const AuditorView = suspendPageLoad(() => import('../views/auditor/AuditorView'));

export const SidebarsLeft = () => {
    return (
        <ReactRouterRoutes>
            <Route path={Routing.transportOrders} element={<WarehouseEmployeeTransportOrderCreationSidebar />} />
            <Route path='*' element={<></>} />
        </ReactRouterRoutes>
    );
};

export const SidebarsRight = () => {
    return (
        <ReactRouterRoutes>
            <Route path={Routing.carrierView} element={<CarrierTransportOrderEditSidebar />} />
            <Route path={Routing.transportOrders} element={<WarehouseEmployeeTransportOrderEditSidebar />} />
            <Route path={Routing.auditorView} element={<AuditorTransportOrderDetailsSidebar />} />
            <Route path='*' element={<></>} />
        </ReactRouterRoutes>
    );
};

export const Routes = () => {
    const props: RoutesProperties = {
        canAccessAuditorView: useAppSelector(isAuditorViewAccessible),
        canAccessCarrierView: useAppSelector(isCarrierViewAccessible),
        canAccessWarehouseEmployeeView: useAppSelector(isWarehouseEmployeeViewAccessible),
    };

    return (
        <ReactRouterRoutes>
            <Route path={Routing.warehouseSelection} element={<WarehouseSelectionView />} />
            <Route path={Routing.transportOrders} element={<WarehouseEmployeeView />} />
            <Route path={Routing.carrierView} element={<CarrierView />} />
            <Route path={Routing.auditorView} element={<AuditorView />} />
            <Route path={'/'} element={<Navigate to={defaultRoute(props)} replace={true} />} />
        </ReactRouterRoutes>
    );
};

export const defaultRoute = (props: RoutesProperties): any => {
    const { canAccessAuditorView, canAccessCarrierView } = props;
    if (canAccessAuditorView) {
        return Routing.auditorView;
    } else if (canAccessCarrierView) {
        return Routing.carrierView;
    }
    return Routing.warehouseSelection;
};
